<ng-content select="[start]" />

<ctx-avatar class="user-row__avatar" size="l" [user]="user()" />

@if (user() | userStatus; as status) {
	<div class="user-row__information">
		@if (user() | userName; as name) {
			<p class="m-0 font-size-medium">{{ user() | userName }}</p>
		} @else {
			<p class="m-0 font-size-medium">{{ user().email }}</p>
		}

		<small>
			{{ 'user.roles.' + user().role | transloco }}
			<span class="margin-h-1">•</span>
			@if (status.value === 'pending') {
				{{
					'user.invited-relative-time'
						| transloco: { time: (user().createdAt | relativeTime) }
				}}
			} @else {
				{{ user().email }}
			}
		</small>
		<ctx-user-invite-expiration-row [state]="inviteExpiration()" />
	</div>

	<div class="user-row__actions">
		@if (showStatus()) {
			<!-- TODO: (Taiga UI migration) [appearance] binding uses a dynamic expression. If it can produce "error"/"success"/"glass", replace with "negative"/"positive"/"secondary-grayscale" -->
			<span tuiBadge [appearance]="status.appearance">
				<tui-icon [icon]="status.icon" />
				<span class="user-row__actions-badge-text">
					{{ status.text | transloco }}
				</span>
			</span>
		}

		<ng-content select="[end]" />

		@if (interactable()) {
			<tui-icon icon="@tui.arrow-right" />
		}
	</div>
}
